import { pagesContent } from 'src/api/Api'
import { SET_GENERAL_DATA } from './types'

export const general = (language) => async (dispatch) => {
  try {
    const generalData = await await pagesContent(language, '/site_generalsettings')
    dispatch({ type: SET_GENERAL_DATA, payload: generalData })
  } catch (error) {
    throw error
  }
}
